import { bool, func, node, number, string } from 'prop-types'

import LoadingIndicator from 'views/components/atoms/LoadingIndicator'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import { usePaginationChangePage } from 'views/components/molecules/Pagination//usePaginationChangePage'

import './PaginationControl.scss'

const PaginationControl = ({
  icon,
  textLabel,
  pageNum,
  onClick,
  scrollToTopAfterClick,
  name,
}) => {
  const { onHandleChangePage, isLoadingAndIsRebranding } =
    usePaginationChangePage({
      handler: onClick,
      pageNum,
      scrollToTopAfterEvent: scrollToTopAfterClick,
    })

  return (
    <div className="l-flex m-PaginationControl">
      <ButtonAsLink name={name} onClick={onHandleChangePage}>
        {isLoadingAndIsRebranding ? (
          <LoadingIndicator
            color="#db002f"
            size={20}
            style={{ marginTop: 4 }}
          />
        ) : (
          icon
        )}
        <span className="u-visuallyhidden">{textLabel}</span>
      </ButtonAsLink>
    </div>
  )
}

PaginationControl.propTypes = {
  onClick: func,
  icon: node.isRequired,
  textLabel: string.isRequired,
  pageNum: number.isRequired,
  scrollToTopAfterClick: bool,
  name: string.isRequired,
}

PaginationControl.defaultProps = {
  onClick: null,
  scrollToTopAfterClick: false,
}

export default PaginationControl
